import React, { useEffect, useMemo, useState } from 'react'
import BaseModal from './BaseModal'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { useDispatch } from 'react-redux'
import { setTrackLibraryModal } from '../../store/reducers/modal.reducer'
import { useTracks } from '../../hooks/useTracks'
import { Autocomplete, Box, Button, TextField } from '@mui/material'
import { byIso } from 'country-code-lookup'
import { TPublicTrack } from '../../shared/types/publicTrack.type'
import { t } from 'i18next'
import { isEmpty } from 'lodash'
import { LoadingButton } from '@mui/lab'

function PublicTracksModal() {
    //State
    const [selectedTracks, setSelectedTracks] = useState<TPublicTrack[]>([])

    //Hooks
    const open = useSelector<RootState>(state => state.modals.tracksLibraryModal) as boolean
    const { getPublicTracks, publicTracks, savePublicTracks, isSavingPublicTracks } = useTracks(false)



    const dispatch = useDispatch()

    useEffect(() => {
        if (open) {
            getPublicTracks()
        }
    }, [open])



    const groupedTracksByCountry = useMemo(() => {
        return publicTracks.map(track => ({
            ...track,
            name: track.training_center_name.concat(' - ').concat(track.name),
            country_code: byIso(track.country_code)?.country ?? track.country_code
        })).sort((a, b) => {
            const countryCompare = a.country_code.localeCompare(b.country_code);
            if (countryCompare !== 0) return countryCompare;

            // then sort by name within the same country
            return a.name.localeCompare(b.name);
        })

    }, [publicTracks])

    //Fns
    const reset = () => {
        dispatch(setTrackLibraryModal(false))
        setSelectedTracks([])
    }

    const saveTracks = async () => {
        if (!isEmpty(selectedTracks)) {

            await savePublicTracks(selectedTracks.map(track => track['@id']))
            reset()
        }
    }

    if (!open) return null


    return (
        <BaseModal title={t('selectFromLib')} open={open} handleClose={reset}>
            <Autocomplete
                options={groupedTracksByCountry}
                groupBy={(option) => option.country_code}
                multiple
                disableCloseOnSelect
                onChange={(_, values) => setSelectedTracks(values)}
                isOptionEqualToValue={(option, value) => option['@id'] === value['@id']}
                getOptionKey={option => option['@id']}
                getOptionLabel={option => option.display_name}
                value={selectedTracks}
                renderInput={(params) => <TextField {...params} label={t('tracks')} />}
                filterSelectedOptions


            />
            <Box display={'flex'} justifyContent={'end'} gap={1} mt={2}>
                <LoadingButton loading={isSavingPublicTracks} onClick={reset}>{t('cancel')}</LoadingButton>
                <LoadingButton loading={isSavingPublicTracks} onClick={saveTracks} disabled={isEmpty(selectedTracks)} variant='contained'>{t('info:save')}</LoadingButton>
            </Box>
        </BaseModal>
    )
}

export default PublicTracksModal